/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAdAgree } from '../../../../actions';
import { fromStore } from '../../../../selectors';

export function AgreeAd() {
  const value = useSelector(fromStore.orderAgreeSelector);
  const createLoader = useSelector(fromStore.createOrderLoaderSelector);
  const user = useSelector(fromStore.userSelector);
  const dispatch = useDispatch();

  if (user && user.adAgree) return null;

  const onChange = (e) => {
    dispatch(setAdAgree(e.target.checked));
  };

  return (
    <div className="d-flex align-items-center mt-2 mb-5">
      <span className="symbol symbol-20px me-2">
        <span className="form-check form-check-danger form-check-solid">
          <input
            className="form-check-input"
            type="checkbox"
            disabled={createLoader}
            onChange={onChange}
            checked={value.adAgree}
          />
        </span>
      </span>
      <span className="fs-5 me-5">
        Согласен получать вкусные новости, акции и персональные предложения от Sushibox
      </span>
    </div>
  );
}
